// const PERMISSIONS_OLD = {
//   AD_SALES_CREATE_EDIT: 1,
//   AD_SALES_ADMIN: 2,
//   AD_SALES_XANDR_APPROVER: 3,
//   MARKETING_CREATE_EDIT: 4,
//   MARKETING_VIEW_ONLY: 5,
//   MARKETING_XANDR_APPROVER: 6,
//   RESEARCH_CREATE_EDIT: 7,
//   RESEARCH_VIEW_ONLY: 8,
//   RESEARCH_XANDR_APPROVER: 9,
//   AD_SALES_MRI_SYMPHONY_CAE: 10,
//   AD_SALES_NCS_SYMPHONY_CAE: 11,
//   AD_SALES_AMRLD_SYMPHONY_CAE: 12,
//   AD_SALES_XANDR_SYMPHONY_CAE: 13,
//   AD_SALES_XANDR_KRUX: 14,
//   AD_SALES_XANDR_LIVE_RAMP: 15,
//   AD_SALES_EPSILON_FB: 16,
//   AD_SALES_EPSILON_HASHED_EMAIL: 17,
//   MARKETING_MRI_SYMPHONY_PHOENIX: 18,
//   MARKETING_XANDR_SYMPHONY_PHOENIX: 19,
//   MARKETING_XANDR_KRUX: 20,
//   MARKETING_XANDR_LIVE_RAMP: 21,
//   RESEARCH_XANDR_SYMPHONY: 22,
//   RESEARCH_XANDR_KRUX: 23,
//   RESEARCH_XANDR_LIVE_RAMP: 24,
//   AD_SALES_XANDR_ATT_TV: 25,
//   AD_SALES_XANDR_VIZIO: 26,
//   AD_SALES_XANDR_CANOE_LINEAR: 27,
//   AD_SALES_XANDR_CANOE_VOD: 28,
//   AD_SALES_ADSTRA_DIRECTV: 29,
//   AD_SALES_ADSTRA_VIZIO: 30,
//   AD_SALES_ADSTRA_CANOE_LINEAR: 31,
//   AD_SALES_ADSTRA_CANOE_VOD: 32,
//   AD_SALES_FREEWHEEL: 33,
//   AD_SALES_GOOGLE_AD_MANAGER: 34,
// }

const CATEGORIES = {
  AD_SALES_ACTIONS: 101,
  MARKETING_ACTIONS: 102,
  RESEARCH_ACTIONS: 103,
  AD_SALES_MRI_DATA_SOURCES: 104,
  AD_SALES_NCS_DATA_SOURCES: 105,
  AD_SALES_AMRLD_DATA_SOURCES: 106,
  AD_SALES_XANDR_DATA_SOURCES: 107,
  AD_SALES_EPSILON_DATA_SOURCES: 108,
  MARKETING_AMRLD_DATA_SOURCES: 109,
  MARKETING_XANDR_DATA_SOURCES: 110,
  RESEARCH_XANDR_DATA_SOURCES: 111,
  AD_SALES_ALL_DATA_SOURCES: 112,
  MARKETING_ALL_DATA_SOURCES: 113,
  RESEARCH_ALL_DATA_SOURCES: 114,
  AM_AD_SALES: 115,
  AM_MARKETING: 116,
  AM_RESEARCH: 117,
  ROOT: 118,
  AD_SALES_ADSTRA_DATA_SOURCES: 119,
}

const ROLES = [
  { name: 'Admin', value: 1 },
  { name: 'Audience Activation Profile', value: 2 },
  { name: 'Sandbox Profile', value: 3 },
]

// PERMISSIONS are fetched from DB and set in @/appLogic/permissions/store/SET_PERMISSIONS

export {
  // PERMISSIONS_OLD,
  CATEGORIES,
  ROLES,
}



// WEBPACK FOOTER //
// ./src/app/appLogic/permissions/Constants.js